import React, {useState} from 'react'
import TabNavItem from './Modules/TabNavItem'
import TabContent from './Modules/TabContent';
import SurveyProperties from './SurveyProperties';
import ElementProperties from './ElementProperties';
import ElementTheme from './ElementTheme';
const ScProperties = () => {
    const [activeTab,setActiveTab] = useState('survey-properties');
    return ( 
        <>
                   
                   <div className="card">
                       <div className="card-body">
                           
                           <ul className="nav nav-tabs">
                                <TabNavItem
                                    id="survey-properties"
                                   
                                    icon="bi bi-card-list"
                                    activeTab={activeTab}
                                    setActiveTab={setActiveTab}
                                    />
                                  <TabNavItem
                                    id="element-properties"
                                  
                                    icon="bi bi-check-square"
                                    activeTab={activeTab}
                                    setActiveTab={setActiveTab}
                                    />
                                    <TabNavItem
                                    id="element-theme"
                                    
                                    icon="bi bi-braces"
                                    activeTab={activeTab}
                                    setActiveTab={setActiveTab}
                                    />
                           </ul>
                           <div className="tab-content pt-2">
                               <TabContent
                                    id="survey-properties" 
                                    activeTab={activeTab}>

                                       <SurveyProperties/>
                                    </TabContent>
                                <TabContent
                                    id="element-properties" 
                                    activeTab={activeTab}>

                                       <ElementProperties/>
                                </TabContent>
                                <TabContent
                                    id="element-theme" 
                                    activeTab={activeTab}>

                                      <ElementTheme/> 
                                </TabContent>
                           </div>
                       </div>
                   </div>

              
        </>
     );
}
 
export default ScProperties;